import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kalyaninagartomumbaitaxi() {



  const cardData =
  {
    keyword: ' Kalyani Nagar to Mumbai Taxi',
    heading: 'Sai Trupti Cabs: Kalyani Nagar to Mumbai Taxi',
    headingDescription: 'Sai Trupti Cabs provides reliable and comfortable Kalyani Nagar to Mumbai taxi services, offering a premium travel experience for both business and leisure trips. Our fleet includes clean, air-conditioned Sedans, SUVs, and Luxury vehicles equipped with plush seating and modern amenities for a relaxed journey. Whether you’re traveling to Mumbai city, Navi Mumbai, or Mumbai Airport, our experienced and background-verified chauffeurs ensure punctual pickups, safe driving, and courteous service every time. With transparent pricing, instant booking confirmation, and 24×7 customer support, Sai Trupti Cabs guarantees a smooth and worry-free intercity ride. Enjoy a convenient and stress-free journey from Kalyani Nagar to Mumbai with Sai Trupti Cabs — your trusted travel partner for safe, affordable, and comfortable taxi services.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, overlooking the Arabian Sea in majestic grandeur. Built in 1924 to commemorate King George V’s visit, it blends Indo-Saracenic architecture with colonial elegance. Tourists flock here to enjoy ferry rides to Elephanta Island and admire the sun setting behind the monument. Surrounded by historic hotels and lively street vendors, it is the perfect starting point for exploring South Mumbai’s heritage charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km boulevard curving gracefully along the Arabian Sea. At night, its glittering streetlights resemble a necklace of pearls, enchanting both locals and travelers. The promenade is perfect for evening strolls, jogs, or simply sitting by the sea breeze. Watching the sunset here with the skyline of Mumbai shimmering in the background offers one of the most serene moments in the bustling metropolis."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is a masterpiece of Victorian Gothic architecture fused with Indian artistry. Built in 1887, this grand railway station pulsates with Mumbai’s heartbeat as thousands commute daily. The ornate domes, pointed arches, and stained glass windows narrate stories of the city’s colonial past. It remains not just a transport hub but an architectural marvel symbolizing Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, about 10 km from Mumbai’s shore, the Elephanta Caves are a UNESCO-listed heritage site dating back to the 5th century. These rock-cut temples are dedicated to Lord Shiva and feature magnificent sculptures, including the colossal Trimurti idol. Accessible by ferry from the Gateway of India, the island offers a mix of history, spirituality, and scenic charm. Visitors are captivated by its ancient artistry and tranquil surroundings."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most beloved seaside destinations, stretching over six kilometers along the Arabian coast. Locals and tourists gather here to relish iconic street foods like pav bhaji, bhel puri, and gola. The evenings come alive with laughter, vendors, and the sound of crashing waves. Watching planes land nearby at sunset makes this beach a truly cinematic Mumbai experience. It’s where relaxation meets the vibrant pulse of city life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a tiny islet off Worli, connected to the mainland by a narrow causeway. Built in the 15th century, it houses the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. The white marble structure surrounded by the sea exudes spiritual peace and architectural beauty. At high tide, the path gets submerged, making the shrine appear to float on water—a breathtaking symbol of faith amidst Mumbai’s urban energy."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is a lush green oasis within the city limits of Mumbai. It offers nature trails, waterfalls, boating, and even a mini zoo for families. The ancient Kanheri Caves nestled inside the park showcase Buddhist rock-cut architecture dating back over 2,000 years. A favorite weekend escape for Mumbaikars, the park perfectly balances nature, history, and adventure in one breathtaking expanse."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks dedicated to Lord Ganesha. Built in 1801, it attracts devotees from across India, including film stars and politicians. The temple’s golden dome and intricately carved idol radiate divine grace. Devotees believe that praying here fulfills wishes, making it a hub of faith, devotion, and cultural unity in the heart of Mumbai."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street known for its eclectic mix of fashion, handicrafts, antiques, and cafés. Whether you’re hunting for souvenirs, jewelry, or bohemian clothing, this market offers it all at irresistible prices. The charming colonial architecture adds to its nostalgic charm. With nearby attractions like the Gateway of India and Leopold Café, Colaba represents the city’s cosmopolitan soul and artistic flair."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai with the western suburbs. Its cable-stayed structure gleams over the Arabian Sea, especially when illuminated at night. Driving across this eight-lane bridge offers panoramic skyline views and a glimpse of Mumbai’s futuristic spirit. The Sea Link is not just a roadway but a symbol of progress, resilience, and Mumbai’s forward-moving ambition."
  }
],



"services": [
  {
    "name": "Kalyani Nagar to Mumbai Taxi",
    "description": "Kalyani Nagar to Mumbai Taxi provides safe, reliable, and convenient transportation for travelers commuting between Kalyani Nagar and Mumbai. With professional drivers, clean vehicles, and timely pickups, this service ensures a hassle-free journey. Features include online booking, multiple payment options, and 24/7 customer support, making it ideal for business, family, or airport travel."
  },
  {
    "name": "Kalyani Nagar to Mumbai Cab",
    "description": "Kalyani Nagar to Mumbai Cab offers comfortable and well-maintained vehicles for intercity travel. Passengers can enjoy punctual pickups, experienced drivers, and a smooth travel experience. The service caters to a wide range of travelers, providing transparent pricing, online booking, and round-the-clock support for stress-free commuting."
  },
  {
    "name": "Kalyani Nagar to Mumbai Car Hire",
    "description": "Kalyani Nagar to Mumbai Car Hire provides a diverse fleet of cars for all types of travelers, including sedans, hatchbacks, SUVs, and luxury vehicles. Options for self-drive and chauffeur-driven cars are available, ensuring flexibility, safety, and comfort. The service also offers online booking, transparent fares, and 24/7 customer assistance."
  },
  {
    "name": "Kalyani Nagar to Mumbai Innova Cab",
    "description": "Kalyani Nagar to Mumbai Innova Cab offers spacious Toyota Innova vehicles perfect for families or groups. Equipped with air-conditioning, ample seating, and luggage space, it ensures a safe and comfortable journey. Real-time tracking, professional drivers, and online booking add convenience and reliability for intercity travel."
  },
  {
    "name": "Kalyani Nagar to Mumbai Ertiga Cab",
    "description": "Kalyani Nagar to Mumbai Ertiga Cab provides medium-sized Maruti Ertiga vehicles suitable for groups and families. With air-conditioned interiors, experienced drivers, and smooth rides, the service ensures a pleasant journey. Online reservations, transparent pricing, and 24/7 support make it a reliable choice for intercity trips."
  },
  {
    "name": "Kalyani Nagar to Mumbai Sedan Cab",
    "description": "Kalyani Nagar to Mumbai Sedan Cab offers mid-sized sedans ideal for solo travelers, couples, or small families. The service includes air-conditioned vehicles, professional drivers, ample luggage space, and smooth rides. Online booking, fare transparency, and 24/7 customer support ensure a dependable and comfortable intercity travel experience."
  },
  {
    "name": "Kalyani Nagar to Mumbai One Way Taxi",
    "description": "Kalyani Nagar to Mumbai One Way Taxi provides economical and convenient single-trip travel for passengers. Featuring punctual pickups, comfortable air-conditioned vehicles, and professional drivers, it ensures safety and reliability. Transparent pricing and online booking make it ideal for one-way travel for business, personal, or airport transfers."
  },
  {
    "name": "Kalyani Nagar to Mumbai Drop Cab",
    "description": "Kalyani Nagar to Mumbai Drop Cab specializes in one-way drop services for hassle-free travel. The service offers experienced drivers, clean vehicles, and transparent fares. With online booking and 24/7 support, it is perfect for intercity trips, airport transfers, and other single-trip journeys."
  },
  {
    "name": "Kalyani Nagar to Mumbai Airport Taxi",
    "description": "Kalyani Nagar to Mumbai Airport Taxi provides dedicated transfers to and from Mumbai airports. Passengers benefit from timely pickups, professional chauffeurs, air-conditioned vehicles, and a comfortable ride. Online booking, real-time tracking, and transparent pricing enhance convenience and reliability for stress-free airport travel."
  },
  {
    "name": "Kalyani Nagar to Mumbai Outstation Cab",
    "description": "Kalyani Nagar to Mumbai Outstation Cab offers long-distance intercity travel with comfortable and well-maintained vehicles. Experienced drivers ensure safe, smooth, and timely travel. The service includes online booking, transparent fares, and 24/7 support, catering to families, business travelers, and tourists seeking dependable transportation."
  },
  {
    "name": "Affordable Kalyani Nagar to Mumbai Taxi",
    "description": "Affordable Kalyani Nagar to Mumbai Taxi provides budget-friendly intercity travel without compromising on comfort or safety. The service features clean, well-maintained vehicles, professional drivers, and transparent pricing. Online booking and 24/7 support make it ideal for students, families, and frequent travelers looking for economical travel options."
  },
  {
    "name": "Kalyani Nagar to Mumbai Luxury Cab",
    "description": "Kalyani Nagar to Mumbai Luxury Cab caters to passengers seeking premium travel experiences. High-end vehicles like BMW, Audi, and Mercedes provide luxurious interiors, professional chauffeurs, and top-notch comfort. The service also offers online booking, transparent pricing, and 24/7 support for executive or VIP travel."
  },
  {
    "name": "Kalyani Nagar to Mumbai Online Cab Booking",
    "description": "Kalyani Nagar to Mumbai Online Cab Booking allows travelers to reserve cabs conveniently from their devices. Multiple vehicle options, instant confirmation, fare transparency, and real-time tracking simplify planning. 24/7 customer support ensures smooth and hassle-free intercity trips from Kalyani Nagar to Mumbai."
  },
  {
    "name": "Kalyani Nagar to Mumbai Taxi near Me",
    "description": "Kalyani Nagar to Mumbai Taxi near Me offers fast access to nearby cabs for immediate or scheduled travel. Features include professional drivers, clean vehicles, transparent pricing, and online booking. The service ensures safe, reliable, and convenient transportation for business, personal, or airport travel."
  },
  {
    "name": "Kalyani Nagar to Mumbai Travel Service",
    "description": "Kalyani Nagar to Mumbai Travel Service provides comprehensive intercity travel solutions including one-way trips, round trips, airport transfers, and group travel. With an emphasis on safety, comfort, and punctuality, the service offers well-maintained vehicles, experienced drivers, online booking, transparent pricing, and 24/7 support for a dependable travel experience."
  }
],
"tableData": [
  ["Kalyani Nagar to Mumbai Taxi", "Kalyani Nagar to Mumbai Cab"],
  ["Kalyani Nagar to Mumbai Car Hire", "Kalyani Nagar to Mumbai Innova Cab"],
  ["Kalyani Nagar to Mumbai Ertiga Cab", "Kalyani Nagar to Mumbai Sedan Cab"],
  ["Kalyani Nagar to Mumbai One Way Taxi", "Kalyani Nagar to Mumbai Drop Cab"],
  ["Kalyani Nagar to Mumbai Airport Taxi", "Kalyani Nagar to Mumbai Outstation Cab"],
  ["Affordable Kalyani Nagar to Mumbai Taxi", "Kalyani Nagar to Mumbai Luxury Cab"],
  ["Kalyani Nagar to Mumbai Online Cab Booking", "Kalyani Nagar to Mumbai Taxi near Me"],
  ["Kalyani Nagar to Mumbai Travel Service", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Kalyani Nagar to Mumbai Taxi Service",
    "WhyChoosedescription": "Sai Trupti Cabs  offers dependable taxi services from Kalyani Nagar (Pune) to Mumbai, ideal for business trips, airport transfers, and leisure travel."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Fare",
    "WhyChoosedescription": "We provide clear one‑way fares from Kalyani Nagar to Mumbai with no hidden charges—what you see is what you pay."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs or premium taxis to suit your group size, luggage and comfort preferences for the Kalyani Nagar‑to‑Mumbai route."
  },
  {
    "WhyChooseheading": "Experienced & Punctual Drivers",
    "WhyChoosedescription": "Our courteous, professional drivers know the Kalyani Nagar to Mumbai route well and ensure a safe, smooth and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop‑off Locations",
    "WhyChoosedescription": "We facilitate convenient pickups in Kalyani Nagar (and nearby Pune suburbs) and drop‑offs across Mumbai—including airports, railway stations and city locations."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All our taxis are regularly serviced, sanitized and maintained to provide a comfortable ride over the long Kalyani Nagar‑to‑Mumbai distance."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, route queries or changes on your Kalyani Nagar to Mumbai taxi journey."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Kalyani Nagar to Mumbai taxi easily via call, WhatsApp or our website—with instant confirmation and prompt dispatch."
  }
]


























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Kalyani Nagar to Mumbai taxi services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Kalyani Nagar to Mumbai taxi services for one way, round trip, and airport transfers.',
  },
  {
    question: 'How can I book a Kalyani Nagar to Mumbai taxi with Sai Trupti Cabs?',
    answer: 'You can easily book your Kalyani Nagar to Mumbai taxi through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of taxis are available from Kalyani Nagar to Mumbai?',
    answer: 'We offer hatchbacks, sedans, SUVs, tempo travellers, and luxury cars to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for the Kalyani Nagar to Mumbai route?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in driving on the Kalyani Nagar–Mumbai route, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I book a Kalyani Nagar to Mumbai taxi for airport transfers?',
    answer: 'Certainly. We provide dedicated Kalyani Nagar to Mumbai airport taxi services with timely pickup and drop-off for both domestic and international terminals.',
  },
  {
    question: 'Is the Kalyani Nagar to Mumbai taxi service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 taxi services from Kalyani Nagar to Mumbai for your convenience and travel flexibility.',
  },
  {
    question: 'What are the Kalyani Nagar to Mumbai taxi fares?',
    answer: 'Our taxi fares start from ₹1,900 for hatchbacks, ₹2,200–₹3,000 for sedans, and ₹3,600 onwards for SUVs, depending on vehicle type and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Kalyani Nagar to Mumbai taxi bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for secure and hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Kalyani Nagar to Mumbai taxis?',
    answer: 'All vehicles are sanitized before every trip, and our drivers strictly follow hygiene and safety measures to ensure a safe journey.',
  },
  {
    question: 'Is customer support available during the Kalyani Nagar to Mumbai taxi ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Kalyani Nagar to Mumbai taxi journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Saurabh Deshmukh',
    feedback: 'I booked a Kalyani Nagar to Mumbai taxi with Sai Trupti Cabs. The driver was punctual, and the ride was smooth and comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Patil',
    feedback: 'Sai Trupti Cabs provided excellent service for my Kalyani Nagar to Mumbai trip. Hassle-free booking and very professional driver.',
    rating: 5,
  },
];

























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kalyani Nagar to Mumbai Taxi",
  "image": "https://saitrupticabs.com/assets/images/kalyani-nagar-to-mumbai-cab.jpg",
  "description": "Book Kalyani Nagar to Mumbai Taxi with Sai Trupti Cabs for a safe, reliable, and affordable journey. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, airport transfers, or outstation travel. Enjoy 24/7 online booking, verified drivers, and on-time service from Kalyani Nagar to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2399",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/kalyani-nagar-to-mumbai-taxi"
  }
};





  return (
    <div>
      <Helmet>
  <title>Kalyani Nagar to Mumbai Taxi | Affordable & Reliable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Kalyani Nagar to Mumbai Taxi with Sai Trupti Cabs for a safe, reliable, and affordable journey. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, airport transfers, or outstation travel. Enjoy 24/7 online booking, verified drivers, and on-time service from Kalyani Nagar to Mumbai." 
  />
  <meta 
    name="keywords" 
    content="Kalyani Nagar to Mumbai Taxi, Kalyani Nagar to Mumbai Cab, Kalyani Nagar to Mumbai Car Hire, Kalyani Nagar to Mumbai Innova Cab, Kalyani Nagar to Mumbai Ertiga Cab, Kalyani Nagar to Mumbai Sedan Cab, Kalyani Nagar to Mumbai One Way Taxi, Kalyani Nagar to Mumbai Drop Cab, Kalyani Nagar to Mumbai Airport Taxi, Kalyani Nagar to Mumbai Outstation Cab, Affordable Kalyani Nagar to Mumbai Taxi, Kalyani Nagar to Mumbai Luxury Cab, Kalyani Nagar to Mumbai Online Cab Booking, Kalyani Nagar to Mumbai Taxi near Me, Kalyani Nagar to Mumbai Travel Service" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/14.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kalyaninagartomumbaitaxi;